
import {initWebComponent} from "@/helpers/web-component-helper";
import {resetMap} from "@/helpers/ol/ol-map-helper";
import {getMapClickMarker} from "@/helpers/ol/ol-map-click-layer-helper";
import {getCenter} from "ol/extent";
import {transform} from "ol/proj";
import {convertToDMS} from "@/helpers/lat-lon-helper";

import {getLatLonProjectionName, getViewProjectionName} from "@/helpers/ol/ol-projection-helper";
import {
    hasDefaultValueParams,
    replaceDefaultValueParams
} from "@/helpers/datatable/datatable-editor-replace-param-helper.js";
import toastr from "toastr";
import {getBySelector, hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper.js";
import {showCyclo} from "@/components/layer/info/info/plugin/layer-info-info-plugin-cyclorama-component.js";


export class RightMouseButtonComponent extends HTMLElement {
    constructor(){
        super();

        const icon = this.getAttribute('data-icon')
        const text = this.getAttribute('data-text')
        let value = this.getAttribute('data-value')

        value = value.replace('admin/rest/kaartviewerapi/', 'admin/v2/kaartviewerapi/')

        const template = document.createElement('template');

        let url = ''

        if(window.selectedLocation) {
            const mapClickMarker = getMapClickMarker()
            if(mapClickMarker) {
                const geometry = mapClickMarker.getSource().getFeatures()[0].getGeometry();

                let center = transform(geometry.flatCoordinates, getViewProjectionName(), 'EPSG:28992')
                url = replaceDefaultValueParams(window.selectedLocation, window.selectedLocationAddress, value, center)
            }
        }

        let disabled = ''
        let type = 'a'
        if(url.includes('$')) {
            disabled = 'disabled="disabled"'
            type = 'button'
        }

        template.innerHTML = `<` + type + ` ` + disabled + ` target="${text.trim()}" href="${url}" title="Klik hier om deze module op te starten" class="mt-2 pl-2 btn btn-outline-secondary p-1 btn-block text-left text-transform-none">
          <span class="` + icon + `" style="margin-top:2px"></span> ` + text + `   
        </` + type + `>
        `;

        initWebComponent(this, template)

        this.addEventListener('click', (e) => {

            if(!hasDefaultValueParams(value)) {
                window.open(value)
                e.preventDefault()
                return
            }

            if(e.target.href === location.href) {

                window.rightMouseButtonValue = value
                e.preventDefault()

                showElementsBySelector('#divRightMouseButtonMessage')
                hideElementsBySelector('#divRightMouseButtonMessageStart')
            } else {
                hideElementsBySelector('#divRightMouseButtonMessage')
                hideElementsBySelector('#divRightMouseButtonMessageStart')
                delete window.rightMouseButtonValue
            }
        })
    }
}
